import { Grid, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Typography } from '@mui/material';

export default function RofBiocharMass({ biocharMass, selectedProject }) {
    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5">Biochar Mass</Typography>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                ProjectId
                            </TableCell>
                            <TableCell align="left">
                                BatchId
                            </TableCell>
                            <TableCell align="left">
                                KilnId
                            </TableCell>
                            <TableCell align="left">
                                BucketId
                            </TableCell>
                            <TableCell align="left">
                                Net Volume {selectedProject?.measureType === 'Imperial' ? <> (yrd<sup>3</sup>)</> : <> (m<sup>3</sup>)</>}
                            </TableCell>
                            <TableCell align="left">
                                Lower Bound Bulk Density {selectedProject?.measureType === 'Imperial' ? <> (lbs/yrd<sup>3</sup>)</> : <> (kg/m<sup>3</sup>)</>}
                            </TableCell>
                            <TableCell align="left">
                                Lower Bound Biochar Mass {selectedProject?.measureType === 'Imperial' ? <>(lbs)</> : <>(kg)</>}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {biocharMass?.data?.map((data, i) => {
                            const isLastIteration = i === biocharMass.length - 1;
                            return (
                                <TableRow key={i}>
                                    <TableCell align="left">
                                        {data.projectId}
                                    </TableCell>
                                    <TableCell align="left">
                                        {data.batchId}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.kilnUsed}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.bucket}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.netVolume}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.lowerBoundBulkDensity}
                                    </TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>
                                        {data.lowerBoundBiocharMass}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                        <TableRow>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>TOTAL</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{biocharMass.totals?.totalNetVolume}</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{biocharMass.totals?.totalLowerBoundBiocharMass}</b></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>AVERAGE</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{biocharMass.totals?.averageNetVolume}</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{biocharMass.totals?.averageLowerBoundBulkDensity}</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{biocharMass.totals?.averageLowerBoundBiocharMass}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}
